import { useSuspenseQuery } from "@tanstack/react-query";
import { CalendarEvent, EventCalendar } from "../components";

import { useAppointmentsStore } from "../store";
import { useState } from "react";

import { calendarAppointmentsQueryOptions } from "../api/queries";
import { getRouteApi } from "@tanstack/react-router";
import { CareEventCalendar } from "../components/care-event-calendar";
import { getApiProgram } from "~/lib/utils";

export function CalendarPage() {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const { view, setView } = useAppointmentsStore();
  const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
  const { program } = routeApi.useParams();
  const appointmentsQuery = useSuspenseQuery(calendarAppointmentsQueryOptions({program: getApiProgram(program)}));

  const handleEventAdd = (event: CalendarEvent) => {
    setEvents([...events, event])
  }

  const handleEventUpdate = (updatedEvent: CalendarEvent) => {
    setEvents(events.map((event) => (event.id === updatedEvent.id ? updatedEvent : event)))
  }

  const handleEventDelete = (eventId: string) => {
    setEvents(events.filter((event) => event.id !== eventId))
  }

  // const transformedEvents = appointmentsQuery.data?.appointments.map(appointment => {
  //   const startDate = new Date(`${appointment.date}T${appointment.time}`);
  //   const event: AppointmentEvent = {
  //     id: appointment.appointment_id,
  //     type: 'appointment',
  //     title: appointment.title,
  //     description: appointment.description,
  //     start: startDate,
  //     end: addHours(startDate, 1),
  //     location: appointment.location,
  //     clientName: appointment.patient.name,
  //     email: appointment.patient.email,
  //     status: appointment.status === 'attended' ? 'completed' : 
  //             appointment.status === 'cancelled' ? 'cancelled' : 'scheduled'
  //   };
  //   return event;
  // }) || [];

  return program === "urgent_care" ? (
    <CareEventCalendar
      events={appointmentsQuery.data}
      view={view}
      // timeRange={}
      setView={setView}
      onEventAdd={handleEventAdd}
      onEventUpdate={handleEventUpdate}
      onEventDelete={handleEventDelete}
    />
  ) : (
    <EventCalendar
      events={appointmentsQuery.data}
      view={view}
      // timeRange={}
      setView={setView}
      onEventAdd={handleEventAdd}
      onEventUpdate={handleEventUpdate}
      onEventDelete={handleEventDelete}
    />
  );
}
